// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import type { Category } from 'app/common/react/components/profile/ProfileSearch/types';
import { Box, IconButton, Text, Touchable } from 'gestalt';

const NON_EXPANDED_CATEGORY_LIMIT = 4;

type Props = {|
  categories: Array<Category>,
  currentCategory: Category | null,
  handleRadioButton: (Category) => void,
|};

type State = {|
  isClicked: boolean,
|};

class CategoryFilter extends React.PureComponent<Props, State> {
  state = {
    isClicked: this.props.categories.length <= NON_EXPANDED_CATEGORY_LIMIT,
  };

  handleTouch = () => {
    this.setState({ isClicked: true });
  };

  render() {
    const { categories, currentCategory, handleRadioButton } = this.props;
    const { isClicked } = this.state;

    return (
      <Box>
        <Box paddingY={4} minWidth={0} width="100%">
          <Text weight="bold">
            {i18n._(
              'Category',
              'Header of product group catagory filter containing filter options',
            )}
          </Text>
        </Box>
        {categories.map((category, index) => (
          <Box key={`category-filter-${index}`}>
            {(index < NON_EXPANDED_CATEGORY_LIMIT || isClicked) && (
              <Box alignItems="center" paddingY={2} display="flex" direction="row">
                <Box flex="grow">
                  <Text>{category.name}</Text>
                </Box>
                <Box>
                  <IconButton
                    icon={
                      currentCategory && currentCategory.id === category.id
                        ? 'check-circle'
                        : 'circle-outline'
                    }
                    accessibilityLabel={i18n._(
                      'category filter option',
                      '[bizpro]- selected category value',
                    )}
                    onClick={() => handleRadioButton(category)}
                    size="sm"
                    iconColor="darkGray"
                  />
                </Box>
              </Box>
            )}
          </Box>
        ))}
        {!isClicked && (
          <Box alignItems="center" paddingY={3} display="flex" direction="row">
            <Touchable onTouch={this.handleTouch}>
              <Box flex="grow">
                <Box>
                  <Text color="gray">
                    {i18n._(
                      'View more',
                      'Click view more to display more categories to choose from',
                    )}
                  </Text>
                </Box>
              </Box>
            </Touchable>
          </Box>
        )}
      </Box>
    );
  }
}

export default CategoryFilter;
